import React from 'react';
import { QNoteForm } from './QNoteForm';

import { Modal } from '@qwealth/qcore';
import { QNote, QTask } from '@qwealth/qdata';

interface QNoteModalProps {
  note?: QNote | null;
  isOpen: boolean;
  householdId?: string;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  onClose: () => void;
  setIsTaskModalOpen?: (isOpen: boolean) => void;
  task?: Partial<QTask> | null;
  isQnoteModalFromTask?: boolean;
}

const QNoteModal: React.FC<QNoteModalProps> = ({
  note,
  onClose,
  isLoading,
  setIsLoading,
  isOpen,
  householdId,
  setIsTaskModalOpen,
  task,
  isQnoteModalFromTask,
}) => (
  <Modal onClose={onClose} show={isOpen} title="QNote" onHide={onClose} size="xl">
    <Modal.Body>
      <QNoteForm
        note={note}
        onClose={onClose}
        householdQID={householdId as string}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        setIsTaskModalOpen={setIsTaskModalOpen}
        task={task}
        isQnoteModalFromTask={isQnoteModalFromTask}
      />
    </Modal.Body>
  </Modal>
);

export default QNoteModal;
